<template>
    <div class="statement-item">
        <div class="statement-item-icon">
            <div :class="['statement-item-account-badge', item.account.color_name]"></div>
            <span v-text="item.category.icon"></span>
        </div>
        <div class="statement-item-info">
            <div class="statement-description" v-text="item.description"></div>
            
            <div class="statement-description" v-if="item.description === null" v-text="item.category.title"></div>
            <div class="statement-category" v-else v-text="item.category.title"></div>
        </div>
        <div class="statement-amount">
            {{ item.amount | money }}
            {{ item.currency | currency }}
        </div>
    </div>
</template>

<script>
export default {
    name: "StatementItem",

    props: ['item'],
}
</script>

<style scoped lang="scss">
.statement-item {
    background: #fff;
    border-radius: 5px;
    margin: 8px 0;

    display: flex;
    align-items: center;
    padding: 10px 12px;

    @media (max-width: 768px) {
        padding: 12px 24px;
    }

    .statement-item-icon {
        font-size: 36px;
        font-family: 'Proxima Nova Rg';
        position: relative;

        .statement-item-account-badge {
            display: block;
            position: absolute;
            top: 0;
            left: -6px;
            width: 11px;
            height: 11px;
            background: #192E4C;
            border-radius: 50%;
            border: 1px solid rgba(#000, .1);
        }
    }

    .statement-item-info {
        margin-left: 16px;
        margin-right: auto;

        font-size: 14px;
        font-family: 'Proxima Nova Rg';
        color: #152640;

        .statement-category {
            color: rgba(#152640, .5);
            margin-top: 6px;
        }
    }

    .statement-amount {
        font-size: 18px;
        font-family: 'Proxima Nova Lt';
        font-weight: 600;
        color: #152640;
        min-width: 100px;
        text-align: right;
    }
}
</style>